import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LoginResponse } from '../models/responses/login.response';
import { DocumentModel } from '../models/document.model';
import { DocumentResponse } from '../models/responses/document.response';
import { DocumentStatusResponse } from '../models/responses/document-status.response';
import { CreateDocumentTypeResponse, DocumentTypeResponse } from '../models/responses/document-type.response';
import { CreateDocumentResponse } from '../models/responses/create-document.response';
import { OfficeResponse } from '../models/responses/office.response';
import { OfficeModel } from '../models/office.model';
import { CreateOfficeResponse } from '../models/responses/create-office.response';
import { CommonResponse } from '../models/responses/common.response';
import { RoleResponse } from '../models/responses/role.response';
import { TrackingStatusResponse } from '../models/responses/tracking-status.response';
import { UsersResponse } from '../models/responses/users.response';
import { UserModel } from '../models/user.model';
import { ProfileResponse } from '../models/responses/profile.response';
import { DocumentTypeModel } from '../models/document-type.model';
import { OrganizationResponse, OrganizationsResponse } from '../models/responses/organization.response';
import { TrackingsModelResponse } from '../models/tracking.model';
import { ReportsResponse } from '../models/responses/reports.response';
import { DocFlowsResponse } from '../models/responses/doc-flows.response';
import { FlowModel } from '../models/flow.model';
import { DocFlowResponse } from '../models/responses/doc-flow.response';
import { UserDocType } from '../models/enums/user-doc-types';
import { DocumentTrackingResponse } from '../models/responses/document-tracking.response';
import { DocumentBadgeResponse } from '../models/responses/document-badge.response';
import { CheckIsSender } from '../models/responses/check-is-sender.response';
import { CountByMenuResponse } from '../models/responses/count-by-menu.response';
import { GeneralDepartmentResponse, GeneralDepartmentsResponse } from '../models/responses/general-department.response';
import { DepartmentResponse, DepartmentsResponse } from '../models/responses/general-department.response copy';
import { GroupsResponse } from '../models/responses/user-groups.response';
import { UserGroupModel } from '../models/user-group.model';
import { CreateUserGroupResponse } from '../models/responses/create-user-group.response';
import { DashboardCountResponse } from '../models/responses/dashboard-count.response';
import { UserGroupConfigResponse } from '../models/responses/user-group-config.response';
import { OrderDocConfigResponse } from '../models/responses/order-doc-config.response';
import { DocumentBadgeSearchResponse } from '../models/responses/document-badge-search.response';
import { DocFlowCategory } from '../models/enums/doc-flow-category';
import { RefreshTokenResponse } from '../models/responses/refresh-token.response';
import { GenerateKeyQr } from '../models/responses/generate-key-qr.response';


export enum Endpoints {
  login = 'login',
  issue_token = 'anonymous_device/issue_token',
  refresh_token = 'login/refresh',
  issue_token_qr = 'cross-auth-device/issue-token',
  profile = 'profile',
  docs = 'docs',
  stampDoc = 'stamp/document',
  docsqr = 'docs/list-qr',
  docsSearch = 'docs/search',
  docsIntoCabinet = 'docs/into-cabinet',
  docsOutCabinet = 'docs/out-cabinet',
  docsNotApproved = 'docs/not-approved',
  docsCompleted = 'docs/completed',
  docsDeleted = 'docs/deleted',
  trackingDocs = 'docs/tracks',
  docById = 'docs/:id',
  stampDocById = 'stamp/document/:id',
  shareDocById = 'docs/share/:doc_id',
  parentDoc = 'docs/replied?id=:id',
  parentDocWithoutID = 'docs/replied',
  editDocById = 'docs/:id',
  stampEditDocById = 'stamp/document/:id',
  editDocPriorityById = 'docs/priority/:id',
  restoreDocById = 'docs/restore/:id',
  searchDoc = 'docs?q=:q',
  searchParentDoc = 'docs/replied?q=:q',
  docStatus = 'doc_status',
  docTypes = 'doc_types',
  docTypesById = 'doc_types/:id',
  offices = 'offices',
  officeTree = 'offices/tree',
  groups = 'user_groups',
  nextLevelDocFlow = 'doc_flows/next',
  docFlows = 'doc_flows',
  docFlowsById = 'doc_flows/:id',
  docFlowConnectionById = 'doc_flows/connection/:id',
  officeTypes = 'office_types',
  officeTypesById = 'office_types/:id',
  officeById = 'offices/:id',
  groupById = 'user_groups/:id',
  officeByName = 'offices/name/:name',
  roles = 'roles',
  trackingStatus = 'tracking_status',
  uploadFileToDocumentById = 'docs/upload/:id',
  stampUploadFileToDocumentById = 'stamp/document/upload/:id',
  downloadFileById = 'docs/download/:doc_id/:file_id?token=:token',
  deleteFileByID = 'docs/file/:doc_id/:id',
  stampDeleteFileByID = 'stamp/document/file/:doc_id/:id',
  users = 'users',
  checkIsSender = 'users/is_sender',
  reports = 'report/office',
  resetPassword = 'users/reset/',
  usersById = 'users/:id',
  usersByName = 'users/name/:name',
  activateUserById = 'users/activate/:id',
  deactivateUserById = 'users/deactivate/:id',
  usersOfficeById = 'users/office/:id',
  usersForShareByDocId = 'users/share/:doc_id',
  organization = 'organization',
  general_department = 'general_department',
  general_departmentById = 'general_department/:id',
  department = 'department',
  departmentById = 'department/:id',
  organizationById = 'organization/:id',
  trackingSendByDocumentId = 'tracking/send/:id',
  trackingSendBackByDocumentId = 'tracking/send_back/:id',
  trackingOffice = 'tracking/office',
  trackingDownloadFileById = 'tracking/download/:doc_id/:tracking_id/:file_id?token=:token',
  trackingAudioDownloadFileById = 'tracking/download/voice/:doc_id/:tracking_id/:file_id?token=:token',
  trackingCount = 'tracking/count-total',
  trackingReceivedByDocId = 'tracking/received/:id',
  trackingDocsById = 'tracking/docs/:id',
  changePassword = 'change_pwd',
  getDashboardCount = 'report/count?start_date=:start_date&end_date=:end_date',
  getDashboardAdminCount = 'report/count/admin?start_date=:start_date&end_date=:end_date',
  barChartInfo = 'report/summary/month?date=:date',
  markAsCompleted = 'tracking/mark-as-completed/:doc_id',
  markAsStamped = 'tracking/mark-as-stamped/:doc_id',
  unsend = 'tracking/cancel_sending/:doc_id',
  getBack = 'tracking/get_back/:doc_id',
  cancelApproved = 'tracking/cancel_approved/:doc_id',
  docBadge = 'docs/count/priority',
  stampDocBadge = 'stamp/document/count/priority',
  searchdocBadge = 'docs/search/count',
  courntByMenu = 'docs/count-by-menu',
  stampCourntByMenu = 'stamp/document/count-by-menu',
  configById = 'config/:id',
  super_leader = 'docs/super-leader',
  docBadgesuper = 'docs/super-leader/count',
  generate_key_qr = 'cross-auth-device/generate-key-qr',
  generate_token_key = 'ocr-access-token/generate',
  api_ocr = 'api/ocr/start',
  api_ocr_stream = 'api/ocr/stream',
  verify_doc = 'verify-doc/view',
  kill_qr_code_session = 'cross-auth-device/kill-qr-code-session',
  scan_qr_file = 'docs/scan-qr',
  search_by_reference = 'docs/search-by-reference',
  search_by_stamp = 'docs/get-doc-created-by-stamp',
  stamp_doc_search = 'stamp/document/get-doc-created-by-stamp'

}

@Injectable({ providedIn: 'root' })
export class ApiService {

  constructor(private http: HttpClient) { }

  public static getUrl(end: Endpoints): string {
    return environment.baseUrl.concat(end);
  }

  public static getUrlOCR(end: Endpoints): string {
    return environment.baseUrl_ocr.concat(end);
  }

  public static getUrlWithParams(end: Endpoints | string, params: { [key: string]: string }): string {
    const regex = new RegExp(Object.keys(params).map(key => `:${key}`).join('|'), 'gi');
    return environment.baseUrl.concat(end).replace(regex, matched => {
      if (!matched) {
        return '';
      }
      return encodeURI(params[matched.replace(':', '')]);
    });
  }

  public login({ userName, password }: { userName: string, password: string }): Observable<LoginResponse> {
    const userAgent = navigator.userAgent;
    const browserType = this.getBrowserType(userAgent);
    const client_instance_id = `${browserType}-${self.crypto.getRandomValues(new Uint32Array(1))[0].toString(16)}`;
    return this.http.post<LoginResponse>(ApiService.getUrl(Endpoints.login), { name: userName, pwd: password, client_instance_id });
  }
  public getAccessToken({ token }: { token: string }): Observable<LoginResponse> {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    return this.http.get<LoginResponse>(
      ApiService.getUrl(Endpoints.issue_token),
      { headers }
    );
  }

  public getAccessTokenQR({ qr_session, client_id }: { qr_session: string, client_id: string }): Observable<any> {
    return this.http.post<any>(ApiService.getUrl(Endpoints.issue_token_qr), { qrcode_key_session: `AUTH:` + qr_session, client_instance_id: client_id });
  }

  public generateQr(): Observable<any> {
    return this.http.get<GenerateKeyQr>(ApiService.getUrl(Endpoints.generate_key_qr),);
  }

  public refreshToken({ refreshToken }: { refreshToken: string }): Observable<any> {
    return this.http.post<RefreshTokenResponse>(
      ApiService.getUrl(Endpoints.refresh_token),
      { token: refreshToken },
    )
  };

  public OCRAccessToken(token: string): Observable<any> {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return this.http.get<any>(ApiService.getUrl(Endpoints.generate_token_key), { headers });
  }

  public OCRUploadFile(file: File, token: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(ApiService.getUrlOCR(Endpoints.api_ocr) + `?token=${token}`, formData);
  }

  getPdfFromUrl(url: string) {
    return this.http.get(url, { responseType: 'blob' });
  }

  buildPdfUrl(token: string) {
    return this.http.get(ApiService.getUrl(Endpoints.verify_doc) + `/${token}`, { responseType: 'blob' });
  }

  public getBusinessDocTitle(file_id: string): Observable<string> {
    return this.http.get(
      ApiService.getUrlOCR(Endpoints.api_ocr_stream) + `/${file_id}`,
      {
        responseType: 'text'
      }
    );
  }

  public scanQrFile(qr_token: string): Observable<any> {
    return this.http.get<any>(ApiService.getUrl(Endpoints.scan_qr_file) + `/${qr_token}`);
  }

  public searchByReference(reference_id: string): Observable<any> {
    return this.http.get<any>(ApiService.getUrl(Endpoints.search_by_reference) + `/${reference_id}`);
  }

  private getBrowserType(userAgent: string): string {
    if (userAgent.includes('Firefox')) return 'firefox';
    if (userAgent.includes('Edg')) return 'edge';
    if (userAgent.includes('Chrome') && !userAgent.includes('Chromium')) return 'chrome';
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'safari';
    if (userAgent.includes('OPR') || userAgent.includes('Opera')) return 'opera';
    return 'unknown';
  }
  public getSaveOnlyDocumentByPage(currentPage = 1, limit = 10, q = '') {
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docs), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        is_approved: false,
        q,
        is_save_only: true
      }
    });
  }
  public getQRlist(currentPage = 1, limit = 10, q = '', date_filter) {
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docsqr), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        q,
        date_filter
      }
    });
  }

  public terminateSessionQRCode(body: any) {
    return this.http.post<any>(ApiService.getUrl(Endpoints.kill_qr_code_session), body)
  }

  public getDocumentsByPage(currentPage = 1, limit = 10, is_approved: boolean, type: UserDocType, is_order: boolean, priority: number, searchText = '', is_save_only = false, is_stamp_doc: boolean = false, is_completed = false, order_by_recently: string): Observable<DocumentResponse> {
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docs), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        is_approved: is_approved,
        is_save_only: is_save_only,
        is_stamp_doc: is_stamp_doc,
        is_completed: is_completed,
        q: searchText,
        type: type ? type : '',
        is_order: is_order != null ? is_order.toString() : '',
        priority: priority == 0 ? '' : priority.toString(),
        order_by_recently: order_by_recently.toString()
      }
    });
  }

  public getStampDocumentsByPage(currentPage = 1, limit = 10, is_approved: boolean, type: UserDocType, is_order: boolean, priority: number, searchText = '', is_save_only = false, is_stamp_doc: boolean = false, is_completed = false, order_by_recently: string): Observable<DocumentResponse> {
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.stampDoc), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        is_approved: is_approved,
        is_save_only: is_save_only,
        is_stamp_doc: is_stamp_doc,
        is_completed: is_completed,
        q: searchText,
        type: type ? type : '',
        is_order: is_order != null ? is_order.toString() : '',
        priority: priority == 0 ? '' : priority.toString(),
        order_by_recently: order_by_recently.toString()
      }
    });
  }

  public getDocumentInDPM(currentPage = 1, limit = 10, priority: number, searchText = '', order_by_recently: string): Observable<DocumentResponse> {
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.super_leader), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        q: searchText,
        priority: priority ? (priority == 0 ? '' : priority.toString()) : '',
        order_by_recently: order_by_recently ? order_by_recently.toString() : 'true'
      }
    });
  }

  public getDocumentBadgeInDPM(priority: number): Observable<DocumentBadgeSearchResponse> {
    return this.http.get<DocumentBadgeSearchResponse>(ApiService.getUrl(Endpoints.docBadgesuper), {
      params: {
        priority: priority == 0 ? '' : priority.toString()
      }
    });
  }

  public getIntoCabinetDocumentsByPage(currentPage = 1, limit = 10, data: any, order?: -1 | 1): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    if (order == undefined) {
      order = -1
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docsIntoCabinet), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        order: order,
        ...data
      }
    });
  }
  public getOutCabinetDocumentsByPage(currentPage = 1, limit = 10, data: any, order?: -1 | 1): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    if (order == undefined) {
      order = -1
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docsOutCabinet), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        order: order,
        ...data
      }
    });
  }
  public getNotApprovedDocumentsByPage(currentPage = 1, limit = 10, data: any, order?: -1 | 1): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    if (order == undefined) {
      order = -1
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docsNotApproved), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        order: order,
        ...data
      }
    });
  }

  public getNotApprovedCount(data: any): Observable<DocumentBadgeSearchResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    return this.http.get<DocumentBadgeSearchResponse>(ApiService.getUrl(Endpoints.docsNotApproved) + '/count', {
      params: data
    });
  }

  public getCompletedDocumentsByPage(currentPage = 1, limit = 10, data: any, order?: -1 | 1): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    if (order == undefined) {
      order = -1
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docsCompleted), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        order: order,
        ...data
      }
    });
  }
  public searchDocumentsByPage(currentPage = 1, limit = 10, data: any, order?: -1 | 1): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    if (order == undefined) {
      order = -1
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docsSearch), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        order: order,
        ...data
      }
    });
  }

  public searchDocumentsByStamp(currentPage = 1, limit = 10, data: any, order?: -1 | 1): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    if (order == undefined) {
      order = -1
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.search_by_stamp), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        order: order,
        ...data
      }
    });
  }

   public stampSearchDocumentsByStamp(currentPage = 1, limit = 10, data: any, order?: -1 | 1): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    if (order == undefined) {
      order = -1
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.stamp_doc_search), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        order: order,
        ...data
      }
    });
  }

  public searchDocumentsDeteledByPage(currentPage = 1, limit = 10, data: any): Observable<DocumentResponse> {
    for (const propName in data) {
      if (data[propName] === null || data[propName] === undefined || data[propName] === '') {
        delete data[propName];
      }
    }
    return this.http.get<DocumentResponse>(ApiService.getUrl(Endpoints.docsDeleted), {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        ...data
      }
    });
  }

  public getDocumentBadgeSearch(is_approved: boolean, is_completed: boolean, doc_category: DocFlowCategory, date: any): Observable<DocumentBadgeSearchResponse> {
    return this.http.get<DocumentBadgeSearchResponse>(ApiService.getUrl(Endpoints.searchdocBadge), {
      params: {
        is_approved,
        is_completed,
        doc_category,
        ...date
      }
    });
  }

  public getDocumentBadge(is_approved: boolean, type: UserDocType, is_order: boolean, is_save_only: boolean = false, is_stamp_doc: boolean = false, is_completed: boolean = false): Observable<DocumentBadgeResponse> {
    return this.http.get<DocumentBadgeResponse>(ApiService.getUrl(Endpoints.docBadge), {
      params: {
        is_approved,
        is_save_only,
        is_stamp_doc,
        is_completed,
        type: type ? type : '',
        is_order: is_order != null ? is_order.toString() : ''
      }
    });
  }

  public getStampDocumentBadge(is_approved: boolean, type: UserDocType, is_order: boolean, is_save_only: boolean = false, is_stamp_doc: boolean = false, is_completed: boolean = false): Observable<DocumentBadgeResponse> {
    return this.http.get<DocumentBadgeResponse>(ApiService.getUrl(Endpoints.stampDocBadge), {
      params: {
        is_approved,
        is_save_only,
        is_stamp_doc,
        is_completed,
        type: type ? type : '',
        is_order: is_order != null ? is_order.toString() : ''
      }
    });
  }

  public getTrackingDocumentsByPage(currentPage = 1, limit = 10, is_approved: boolean, is_send_back: boolean, group_by = "day", searchText = ''): Observable<DocumentTrackingResponse> {
    return this.http.get<DocumentTrackingResponse>(ApiService.getUrl(Endpoints.trackingDocs) + '/' + group_by, {
      params: {
        page: currentPage.toString(10),
        limit: limit.toString(10),
        q: searchText,
        approved: is_approved != null ? is_approved.toString() : '',
        send_back: is_send_back != null ? is_send_back.toString() : '',
      }
    });
  }

  public getCountDocuments(type: UserDocType = UserDocType.CREATOR): Observable<{ status: number, total: number }> {
    return this.http.get<{ status: number, total: number }>(ApiService.getUrl(Endpoints.docs), {
      params: {
        type
      }
    });
  }

  public changeOwnPassword(newPassword: string, oldPassword: string) {
    return this.http.post<any>(ApiService.getUrl(Endpoints.changePassword), {
      old_pwd: oldPassword,
      new_pwd: newPassword
    });
  }

  public createDocument(document: DocumentModel): Observable<CreateDocumentResponse> {
    return this.http.post<CreateDocumentResponse>(ApiService.getUrl(Endpoints.docs), document);
  }

  public stampCreateDocument(document: DocumentModel): Observable<CreateDocumentResponse> {
    return this.http.post<CreateDocumentResponse>(ApiService.getUrl(Endpoints.stampDoc), document);
  }

  public editDocument(docID: string, document: DocumentModel): Observable<CreateDocumentResponse> {
    return this.http.patch<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.editDocById, { id: docID }), document);
  }

  public stampEditDocument(docID: string, document: DocumentModel): Observable<CreateDocumentResponse> {
    return this.http.patch<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.stampEditDocById, { id: docID }), document);
  }

  public editDocumentPriority(docID: string, priority: number): Observable<CreateDocumentResponse> {
    return this.http.patch<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.editDocPriorityById, { id: docID }), { priority });
  }
  public getDocumentStatuses(): Observable<DocumentStatusResponse> {
    return this.http.get<DocumentStatusResponse>(ApiService.getUrl(Endpoints.docStatus));
  }

  public getDocumentById(id: string, tracking_status: number = null): Observable<CreateDocumentResponse> {
    return this.http.get<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.docById, { id: id }));
  }

  public getStampDocumentById(id: string, tracking_status: number = null): Observable<CreateDocumentResponse> {
    return this.http.get<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.stampDocById, { id: id }));
  }

  public getParentDocument(id: string): Observable<CreateDocumentResponse> {
    return this.http.get<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.parentDoc, { id }));
  }

  public getParentDocumentWithoutID(): Observable<CreateDocumentResponse> {
    return this.http.get<CreateDocumentResponse>(ApiService.getUrl(Endpoints.parentDocWithoutID));
  }

  public searchParentDocument(searchText: string) {
    return this.http.get<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.searchParentDoc, { searchText }));
  }

  public getDocumentTypes(): Observable<DocumentTypeResponse> {
    return this.http.get<DocumentTypeResponse>(ApiService.getUrl(Endpoints.docTypes));
  }

  public createDocumentType(type: DocumentTypeModel): Observable<CreateDocumentTypeResponse> {
    return this.http.post<CreateDocumentTypeResponse>(ApiService.getUrl(Endpoints.docTypes), type);
  }

  public editDocumentType(documentTypeId: string, body: DocumentTypeModel): Observable<CreateDocumentTypeResponse> {
    return this.http.patch<CreateDocumentTypeResponse>(ApiService.getUrlWithParams(Endpoints.docTypesById, { id: documentTypeId }), body);
  }

  public deleteDocumentType(documentTypeId: string): Observable<CommonResponse> {
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.docTypesById, { id: documentTypeId }));
  }

  public getOffices(): Observable<OfficeResponse> {
    return this.http.get<OfficeResponse>(ApiService.getUrl(Endpoints.offices));
  }
  public getOfficeTree(): Observable<OfficeResponse> {
    return this.http.get<OfficeResponse>(ApiService.getUrl(Endpoints.officeTree));
  }

  public getGroups(): Observable<GroupsResponse> {
    return this.http.get<GroupsResponse>(ApiService.getUrl(Endpoints.groups));
  }
  public getDocFlows(): Observable<DocFlowsResponse> {
    return this.http.get<DocFlowsResponse>(ApiService.getUrl(Endpoints.docFlows));
  }

  public getNextLevelOfficeFlows(): Observable<OfficeResponse> {
    return this.http.get<OfficeResponse>(ApiService.getUrl(Endpoints.nextLevelDocFlow));
  }

  public createDocFlow(docFlow: FlowModel): Observable<DocFlowResponse> {
    return this.http.post<DocFlowResponse>(ApiService.getUrl(Endpoints.docFlows), {
      office: docFlow.office._id,
      level: docFlow.level
    });
  }

  public deleteDocFlow(id: string): Observable<CommonResponse> {
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.docFlowsById, { id }));
  }

  public createDocFlowConnection(id: string, child: string): Observable<DocFlowResponse> {
    return this.http.post<DocFlowResponse>(ApiService.getUrlWithParams(Endpoints.docFlowConnectionById, { id }), {
      child
    });
  }

  public deleteDocFlowConnection(id: string, child: string): Observable<CommonResponse> {
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.docFlowConnectionById, { id }), {
      params: {
        child
      }
    });
  }

  public deleteOfficeType(officeTypeId: string): Observable<CommonResponse> {
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.officeTypesById, { id: officeTypeId }));
  }


  public getProfile(): Observable<ProfileResponse> {
    return this.http.get<ProfileResponse>(ApiService.getUrl(Endpoints.profile));
  }

  public getOfficeById(officeId: string): Observable<CreateOfficeResponse> {
    return this.http.get<CreateOfficeResponse>(ApiService.getUrlWithParams(Endpoints.officeById, {
      id: officeId
    }));
  }

  public deleteOfficeById(officeId: string): Observable<CommonResponse> {
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.officeById, {
      id: officeId
    }));
  }

  public deleteGroupById(groupId: string): Observable<CommonResponse> {
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.groupById, {
      id: groupId
    }));
  }
  public modifyOfficeById(officeId: string, office: OfficeModel): Observable<CreateOfficeResponse> {
    return this.http.patch<CreateOfficeResponse>(ApiService.getUrlWithParams(Endpoints.officeById, {
      id: officeId
    }), office);
  }

  public modifyGroupById(groupId: string, group: UserGroupModel): Observable<CreateUserGroupResponse> {
    return this.http.patch<CreateUserGroupResponse>(ApiService.getUrlWithParams(Endpoints.groupById, {
      id: groupId
    }), group);
  }

  public findOfficeByName(officeName: string): Observable<OfficeResponse> {
    return this.http.get<OfficeResponse>(ApiService.getUrlWithParams(Endpoints.officeByName, {
      name: officeName
    }));
  }

  public setUserStatus(userId: string, status: boolean): Observable<UserModel> {
    let requestUrl: string;
    if (status) {
      requestUrl = Endpoints.activateUserById;
    } else {
      requestUrl = Endpoints.deactivateUserById;
    }

    return this.http.post<UserModel>(ApiService.getUrlWithParams(requestUrl, { id: userId }), {});
  }

  public createNewOffice(office: OfficeModel): Observable<CreateOfficeResponse> {
    return this.http.post<CreateOfficeResponse>(ApiService.getUrl(Endpoints.offices), office);
  }

  public createNewGroup(office: UserGroupModel): Observable<CreateUserGroupResponse> {
    return this.http.post<CreateUserGroupResponse>(ApiService.getUrl(Endpoints.groups), office);
  }


  public editUser(userId: string, body: {
    name: string,
    role_id: number,
    office_id: string,
    pwd: string,
    title: string,
    first_name: string,
    last_name: string
  }): Observable<LoginResponse> {
    return this.http.patch<LoginResponse>(ApiService.getUrlWithParams(Endpoints.usersById, {
      id: userId
    }), body);
  }

  public getRoles(): Observable<RoleResponse> {
    return this.http.get<RoleResponse>(ApiService.getUrl(Endpoints.roles));
  }

  public checkIsSender(): Observable<CheckIsSender> {
    return this.http.get<CheckIsSender>(ApiService.getUrl(Endpoints.checkIsSender));
  }

  public createUser(body: {
    name: string,
    role_id: number,
    office_id: string,
    pwd: string,
    title: string,
    first_name: string,
    last_name: string
  }): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(ApiService.getUrl(Endpoints.users), body);
  }

  public getUsers(office_id: string, name: string, limit: number = 10, page: number = 1): Observable<UsersResponse> {
    return this.http.get<UsersResponse>(ApiService.getUrl(Endpoints.users), {
      params: {
        office_id,
        name,
        limit: limit.toString(),
        page: page.toString()
      }
    });
  }

  public getUsersByName(name: string): Observable<UsersResponse> {
    return this.http.get<UsersResponse>(ApiService.getUrlWithParams(Endpoints.usersByName, { name }));
  }

  public getTrackingStatuses(): Observable<TrackingStatusResponse> {
    return this.http.get<TrackingStatusResponse>(ApiService.getUrl(Endpoints.trackingStatus));
  }

  public getUsersByOffice(officeId: string): Observable<UsersResponse> {
    return this.http.get<UsersResponse>(ApiService.getUrlWithParams(Endpoints.usersOfficeById, { id: officeId }));
  }

  public getUsersForShare(doc_id: string): Observable<UsersResponse> {
    return this.http.get<UsersResponse>(ApiService.getUrlWithParams(Endpoints.usersForShareByDocId, { doc_id }));
  }

  public resetPassword(userID: string, newPassword: string): Observable<UsersResponse> {
    return this.http.post<UsersResponse>(ApiService.getUrl(Endpoints.resetPassword).concat(userID), { password: newPassword });
  }

  public getOrganization(doc_type: string = null, type: string = null): Observable<OrganizationsResponse> {
    return this.http.get<OrganizationsResponse>(ApiService.getUrl(Endpoints.organization), {
      params: {
        doc_type,
        type
      }
    });
  }

  public getGeneralDepartment(organization: string = null): Observable<GeneralDepartmentsResponse> {
    return this.http.get<GeneralDepartmentsResponse>(ApiService.getUrl(Endpoints.general_department), {
      params: {
        organization
      }
    });
  }

  public getDepartment(general_department: string = null): Observable<DepartmentsResponse> {
    return this.http.get<DepartmentsResponse>(ApiService.getUrl(Endpoints.department), {
      params: {
        general_department
      }
    });
  }
  public createOrganization(doc_type: string, type: string, name: string): Observable<OrganizationResponse> {
    return this.http.post<OrganizationResponse>(ApiService.getUrl(Endpoints.organization), {
      doc_type,
      type,
      name
    });
  }
  public createGeneralDepartment(organization: string, name: string): Observable<GeneralDepartmentResponse> {
    return this.http.post<GeneralDepartmentResponse>(ApiService.getUrl(Endpoints.general_department), {
      organization,
      name
    });
  }

  public editGeneralDepartment(general_department: string, old_name: string, new_name: string): Observable<GeneralDepartmentResponse> {
    return this.http.patch<GeneralDepartmentResponse>(ApiService.getUrlWithParams(Endpoints.general_departmentById, { id: general_department }), {
      old_name,
      new_name
    });
  }

  public createDepartment(general_department: string, name: string): Observable<DepartmentResponse> {
    return this.http.post<DepartmentResponse>(ApiService.getUrl(Endpoints.department), {
      general_department,
      name
    });
  }

  public editDepartment(department: string, new_name: string): Observable<DepartmentResponse> {
    return this.http.patch<DepartmentResponse>(ApiService.getUrlWithParams(Endpoints.departmentById, { id: department }), {
      new_name
    });
  }


  // public editOrganization(id: string, name: string): Observable<OrganizationResponse> {
  //   return this.http.patch<OrganizationResponse>(ApiService.getUrlWithParams(Endpoints.organizationById, { id }), {

  //     name
  //   });
  // }

  // public deleteOrganization(id: string): Observable<CommonResponse> {
  //   return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.organizationById, { id }));
  // }


  public uploadFileToDocument(documentId: string, file: File): Observable<HttpEvent<Response>> {

    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data;boundary=abc');

    const req = new HttpRequest('POST', ApiService.getUrlWithParams(Endpoints.uploadFileToDocumentById, {
      id: documentId
    }), formData, {
      reportProgress: true,
      responseType: 'json',
      headers: headers
    });

    return this.http.request<Response>(req);
  }

  public stampUploadFileToDocument(documentId: string, file: File): Observable<HttpEvent<Response>> {

    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data;boundary=abc');

    const req = new HttpRequest('POST', ApiService.getUrlWithParams(Endpoints.stampUploadFileToDocumentById, {
      id: documentId
    }), formData, {
      reportProgress: true,
      responseType: 'json',
      headers: headers
    });

    return this.http.request<Response>(req);
  }

  public sendDocumentToOffice(documentId: string, body: { files: File[], copied_users: UserModel[], to: string, comment: string, receiver: string, approved_by, hide_previous_comment: boolean }): Observable<HttpEvent<Response>> {
    const formData = new FormData();
    const httpHeaders = new HttpHeaders();
    httpHeaders.append('Content-Type', 'multipart/form-data;boundary=abc');
    if (body.files) {
      Array.from(body.files).forEach(file => formData.append('file', file));
    }

    formData.append('to', body.to);
    formData.append('comment', body.comment);
    formData.append('receiver', body.receiver);
    formData.append('approved_by', body.approved_by);
    body.copied_users?.forEach(user => {
      formData.append('copied_users[]', user._id);
    })

    formData.append('hide_previous_comment', body.hide_previous_comment ? 'true' : 'false');

    return this.http.request<Response>(new HttpRequest('POST', ApiService.getUrlWithParams(Endpoints.trackingSendByDocumentId, {
      id: documentId
    }), formData, {
      reportProgress: true,
      responseType: 'json',
      headers: httpHeaders
    }));
  }

  public sendDocumentBack(documentId: string, body: { files: File[], copied_users: UserModel[], comment: string }, is_approved: boolean = false): Observable<HttpEvent<Response>> {
    const formData = new FormData();
    const httpHeaders = new HttpHeaders();
    httpHeaders.append('Content-Type', 'multipart/form-data;boundary=abc');
    if (body.files) {
      Array.from(body.files).forEach(file => formData.append('file', file));
    }

    formData.append('comment', body.comment);
    body.copied_users?.forEach(user => {
      formData.append('copied_users[]', user._id);
    })
    if (is_approved) {
      formData.append('is_approved', 'true');
    }

    return this.http.request<Response>(new HttpRequest('POST', ApiService.getUrlWithParams(Endpoints.trackingSendBackByDocumentId, {
      id: documentId
    }), formData, {
      reportProgress: true,
      responseType: 'json',
      headers: httpHeaders
    }));
  }

  public shareDoc(doc_id: string, users: string[]): Observable<CreateDocumentResponse> {
    return this.http.post<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.shareDocById, { doc_id }), { users });
  }

  public markAsCompleted(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.patch<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.markAsCompleted, { doc_id }), {});
  }

  public markAsApprovedStamp(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.patch<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.markAsStamped, { doc_id }), {});
  }

  public unsendDoc(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.post<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.unsend, { doc_id }), {});
  }

  public getBackDoc(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.post<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.getBack, { doc_id }), {});
  }

  public cancelApprovedDoc(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.post<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.cancelApproved, { doc_id }), {});
  }

  public deleteDoc(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.delete<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.editDocById, { id: doc_id }), {});
  }

  public stampDeleteDoc(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.delete<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.stampEditDocById, { id: doc_id }), {});
  }

  public restoreDoc(doc_id: string): Observable<CreateDocumentResponse> {
    return this.http.post<CreateDocumentResponse>(ApiService.getUrlWithParams(Endpoints.restoreDocById, { id: doc_id }), {});
  }

  public getTrackingOffice(): Observable<TrackingsModelResponse> {
    return this.http.get<TrackingsModelResponse>(ApiService.getUrl(Endpoints.trackingOffice));
  }

  public getUrlTrackingAudioFileById(doc_id: string, tracking_id: string, file_id: string, token: string): string {
    return ApiService.getUrlWithParams(Endpoints.trackingAudioDownloadFileById, { doc_id, tracking_id, file_id, token });
  }

  public downloadTrackingFileById(doc_id: string, tracking_id: string, file_id: string, token: string): string {
    return ApiService.getUrlWithParams(Endpoints.trackingDownloadFileById, { doc_id, tracking_id, file_id, token });
  }

  public downloadFileById(doc_id: string, file_id: string, token: string): string {
    return ApiService.getUrlWithParams(Endpoints.downloadFileById, { doc_id, file_id, token });
  }

  public deleteFileById(doc_id: string, id: string): Observable<CommonResponse> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.append('Content-Type', 'multipart/form-data;boundary=abc');
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.deleteFileByID, { doc_id: doc_id, id: id }),
      {
        reportProgress: true,
        responseType: 'json',
        headers: httpHeaders
      });
  }

  public stampDeleteFileById(doc_id: string, id: string): Observable<CommonResponse> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.append('Content-Type', 'multipart/form-data;boundary=abc');
    return this.http.delete<CommonResponse>(ApiService.getUrlWithParams(Endpoints.stampDeleteFileByID, { doc_id: doc_id, id: id }),
      {
        reportProgress: true,
        responseType: 'json',
        headers: httpHeaders
      });
  }

  public countTracking(): Observable<{ status: number, data: number }> {
    return this.http.get<{ status: number, data: number }>(ApiService.getUrl(Endpoints.trackingCount));
  }

  public trackingReceivedDocument(docId: string, comment?: string): Observable<Response> {
    return this.http.post<Response>(ApiService.getUrlWithParams(Endpoints.trackingReceivedByDocId, { id: docId }), { comment });
  }


  public getTrackingOfDocument(documentId: string): Observable<TrackingsModelResponse> {
    return this.http.get<TrackingsModelResponse>(ApiService.getUrlWithParams(Endpoints.trackingDocsById, { id: documentId }));
  }

  public editProfile(body: { first_name: string, last_name: string }): Observable<{ message: string, status: number, profile: UserModel }> {
    return this.http.patch<{ message: string, status: number, profile: UserModel }>(ApiService.getUrl(Endpoints.profile), body);
  }

  public getReports(condiction: any): Observable<ReportsResponse> {
    return this.http.get<ReportsResponse>(ApiService.getUrl(Endpoints.reports), {
      params: condiction
    });
  }

  public getDashboardCount(startDate: string, endDate: string) {
    return this.http.get<DashboardCountResponse>(ApiService.getUrlWithParams(Endpoints.getDashboardCount, { start_date: startDate, end_date: endDate }));
  }

  public getDashboardAdminCount(startDate: string, endDate: string) {
    return this.http.get<DashboardCountResponse>(ApiService.getUrlWithParams(Endpoints.getDashboardAdminCount, { start_date: startDate, end_date: endDate }));
  }


  public getBarChartInfo(startDate: string) {
    return this.http.get<any>(ApiService.getUrlWithParams(Endpoints.barChartInfo, { date: startDate }));
  }

  public countByMenu() {
    return this.http.get<CountByMenuResponse>(ApiService.getUrlWithParams(Endpoints.courntByMenu, {}));
  }

  public stampCountByMenu() {
    return this.http.get<CountByMenuResponse>(ApiService.getUrlWithParams(Endpoints.stampCourntByMenu, {}));
  }

  public getUserGroupConfig() {
    return this.http.get<UserGroupConfigResponse>(ApiService.getUrlWithParams(Endpoints.configById, { id: 'user_group' }));
  }

  public getOrderDocConfig() {
    return this.http.get<OrderDocConfigResponse>(ApiService.getUrlWithParams(Endpoints.configById, { id: 'order_doc' }));
  }
}



